import { defineComponent as _defineComponent } from 'vue';
import { vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from '@/assets/img/loading.svg';
var _hoisted_1 = { class: "draft-item-container" };
var _hoisted_2 = ["src-oringal", "src", "alt"];
var _hoisted_3 = {
    key: 1,
    src: _imports_0,
    alt: "load-cover",
    class: "draft-item-cover-load"
};
var _hoisted_4 = {
    key: 2,
    class: "no-cover-aria flex-center"
};
var _hoisted_5 = { class: "draft-info-container" };
var _hoisted_6 = { class: "post-title" };
var _hoisted_7 = { class: "draft-info-detail" };
var _hoisted_8 = ["title"];
var _hoisted_9 = { class: "category" };
var _hoisted_10 = { class: "draft-options-item draft-options-delete" };
var _hoisted_11 = { class: "draft-options-item draft-item-to-top" };
var _hoisted_12 = { class: "draft-options-item draft-options-release" };
var _hoisted_13 = {
    key: 0,
    class: "ribbon-3"
};
import { ref, computed, toRef } from "vue";
import tools from "@/utils/tools";
import api from "@/utils/api";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PostDraftItemBox',
    props: {
        title: {},
        category: {},
        tags: {},
        draftID: {},
        lastUpdateTime: {},
        isRelease: { type: Boolean },
        cover: {},
        id: {},
        onDelete: { type: Function },
        onToTop: { type: Function }
    },
    setup: function (__props) {
        var props = __props;
        var title = toRef(props.title);
        var draftID = toRef(props.draftID);
        var lastUpdateTime = toRef(props.lastUpdateTime);
        var category = toRef(props.category);
        var cover = toRef(props.cover);
        var isRelease = toRef(props.isRelease);
        var optionsIconSize = ref("25");
        var isLoaded = ref(false), isShowOptions = ref(false);
        var optionsGroupItem = ref(null);
        var showOptionsStyle = computed(function () {
            if (!optionsGroupItem.value)
                return {};
            return {
                // right: `${
                //   isShowOptions.value
                //     ? 0
                //     : -(optionsGroupItem.value as HTMLElement).offsetWidth // 或 ref<HTMLElement | null>(null)
                // }px`,
                right: isShowOptions.value
                    ? "0px"
                    : "calc(-".concat(optionsGroupItem.value.offsetWidth // 或 ref<HTMLElement | null>(null)
                    , "px - ").concat(getComputedStyle(optionsGroupItem.value).getPropertyValue("--options-folder-gap"), ")"),
            };
        });
        var gotoDraftEdit = function () {
            tools.jumptoLocal("/edit/post-edit?uuid=".concat(draftID.value));
        };
        function onLoad() {
            isLoaded.value = true;
        }
        function onError() {
            window.$notifyError("图片加载失败", "请检查网络连接");
        }
        function handleDelete() {
            api.request
                .quickPost("/deletedraft", {
                draftID: draftID.value,
            })
                .then(function (resp) {
                var res = resp;
                props.onDelete(draftID.value);
                window.$notifySuccess("删除成功", "草稿已成功删除");
            })
                .catch(function (err) {
                var res = err.response;
                window.$notifyError("草稿删除失败", res.msg);
            });
        }
        function handleToTop() {
            api.requestWithoutMask
                .quickPost("/topdraft", {
                draftID: draftID.value,
            })
                .then(function (res) {
                var resp = res;
                if (resp.code !== 0) {
                    window.$notifyError("草稿数据端置顶失败", resp.msg);
                }
            });
            props.onToTop(draftID.value);
        }
        function handleRelease() {
            api.request
                .quickPost("/releasedraft", {
                draftID: draftID.value,
            })
                .then(function (res) {
                window.$notifySuccess("发布成功", "草稿已成功发布");
                props.onDelete(draftID.value);
            })
                .catch(function (err) {
                var resp = err.response;
                window.$notifyError("草稿发布失败", resp.msg);
            });
        }
        return function (_ctx, _cache) {
            var _component_n_icon = _resolveComponent("n-icon");
            var _component_CustomSVG = _resolveComponent("CustomSVG");
            var _component_n_button = _resolveComponent("n-button");
            var _component_n_tooltip = _resolveComponent("n-tooltip");
            return (_openBlock(), _createElementBlock("div", {
                class: "post-draft-item-box",
                onClick: gotoDraftEdit
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", {
                        class: _normalizeClass([
                            'draft-img-container',
                            { 'draft-img-container-no-mask': !isLoaded.value },
                        ])
                    }, [
                        (cover.value !== undefined && cover.value !== null && cover.value !== '')
                            ? _withDirectives((_openBlock(), _createElementBlock("img", {
                                key: 0,
                                "src-oringal": cover.value,
                                src: "/draft/".concat(draftID.value, "/").concat(cover.value),
                                alt: title.value,
                                class: "draft-item-cover",
                                onLoad: onLoad,
                                onError: onError
                            }, null, 40, _hoisted_2)), [
                                [_vShow, isLoaded.value]
                            ])
                            : _createCommentVNode("", true),
                        (!isLoaded.value && cover.value !== undefined && cover.value !== null && cover.value !== '')
                            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                            : _createCommentVNode("", true),
                        (cover.value === undefined || cover.value === null || cover.value === '')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[2] || (_cache[2] = [
                                _createElementVNode("i", { class: "fa-solid fa-image draft-manage-no-cover" }, null, -1)
                            ])))
                            : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(title.value), 1),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("span", {
                                class: "last-update-time",
                                title: lastUpdateTime.value
                            }, _toDisplayString("\u4E0A\u6B21\u7F16\u8F91\uFF1A".concat(_unref(tools).countHowManyTimesAgo(lastUpdateTime.value))), 9, _hoisted_8),
                            _createElementVNode("span", _hoisted_9, _toDisplayString("\u5206\u7C7B\uFF1A".concat(category.value || "暂无分类")), 1)
                        ])
                    ]),
                    _createElementVNode("div", {
                        class: "draft-info-operations",
                        onMouseenter: _cache[0] || (_cache[0] = function ($event) { return (isShowOptions.value = true); }),
                        onMouseleave: _cache[1] || (_cache[1] = function ($event) { return (isShowOptions.value = false); }),
                        style: _normalizeStyle(showOptionsStyle.value)
                    }, [
                        _createVNode(_component_n_icon, {
                            size: optionsIconSize.value,
                            class: "draft-options-show-icon-container",
                            color: "var(--font-color-reverse)"
                        }, {
                            default: _withCtx(function () { return [
                                _createElementVNode("i", {
                                    class: _normalizeClass([
                                        'fa-solid',
                                        'fa-angle-left',
                                        'draft-options-group-trigger-icon',
                                        { 'draft-options-group-trigger-icon-show': isShowOptions.value },
                                    ])
                                }, null, 2)
                            ]; }),
                            _: 1
                        }, 8, ["size"]),
                        _createElementVNode("div", {
                            class: "draft-options-container",
                            ref_key: "optionsGroupItem",
                            ref: optionsGroupItem
                        }, [
                            _createElementVNode("div", _hoisted_10, [
                                _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                                    trigger: _withCtx(function () { return [
                                        _createVNode(_component_n_button, {
                                            quaternary: "",
                                            circle: "",
                                            size: "large",
                                            onClick: _withModifiers(handleDelete, ["stop"])
                                        }, {
                                            icon: _withCtx(function () { return [
                                                _createVNode(_component_n_icon, {
                                                    size: optionsIconSize.value,
                                                    color: "var(--font-color-reverse)"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _createVNode(_component_CustomSVG, { icon: "Delete24Filled" })
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["size"])
                                            ]; }),
                                            _: 1
                                        })
                                    ]; }),
                                    default: _withCtx(function () { return [
                                        _cache[3] || (_cache[3] = _createTextVNode(" 删除 "))
                                    ]; }),
                                    _: 1
                                })
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                                    trigger: _withCtx(function () { return [
                                        _createVNode(_component_n_button, {
                                            quaternary: "",
                                            circle: "",
                                            size: "large",
                                            onClick: _withModifiers(handleToTop, ["stop"])
                                        }, {
                                            icon: _withCtx(function () { return [
                                                _createVNode(_component_n_icon, {
                                                    size: optionsIconSize.value,
                                                    color: "var(--font-color-reverse)"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _createVNode(_component_CustomSVG, { icon: "WindowArrowUp24Filled" })
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["size"])
                                            ]; }),
                                            _: 1
                                        })
                                    ]; }),
                                    default: _withCtx(function () { return [
                                        _cache[4] || (_cache[4] = _createTextVNode(" 置顶 "))
                                    ]; }),
                                    _: 1
                                })
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                                    trigger: _withCtx(function () { return [
                                        _createVNode(_component_n_button, {
                                            quaternary: "",
                                            circle: "",
                                            size: "large",
                                            onClick: _withModifiers(handleRelease, ["stop"])
                                        }, {
                                            icon: _withCtx(function () { return [
                                                _createVNode(_component_n_icon, {
                                                    size: optionsIconSize.value,
                                                    color: "var(--font-color-reverse)"
                                                }, {
                                                    default: _withCtx(function () { return [
                                                        _createVNode(_component_CustomSVG, { icon: "AddTaskOutlined" })
                                                    ]; }),
                                                    _: 1
                                                }, 8, ["size"])
                                            ]; }),
                                            _: 1
                                        })
                                    ]; }),
                                    default: _withCtx(function () { return [
                                        _cache[5] || (_cache[5] = _createTextVNode(" 发布 "))
                                    ]; }),
                                    _: 1
                                })
                            ])
                        ], 512)
                    ], 36)
                ]),
                (isRelease.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[6] || (_cache[6] = [
                        _createElementVNode("span", null, "发布中", -1)
                    ])))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
